import { API_URL } from '../constants/config'
import { query } from './utilities'

const fetchUserByOpportunityIdProd = (opportunityId) =>
  query(`${API_URL}/Customer/${opportunityId}/${global.config.brand}`)

export const fetchUserByOpportunityId = fetchUserByOpportunityIdProd
